import PersonalizationCardImage from "../components/PersonalizationCardImage";
import PersonalizationInput from "../components/PersonalizationInput";
import PersonalizationTextarea from "../components/PersonalizationTextarea";

export default function WellnessWelcomeScreen({getWellnessError, wellnessFormData,setWellnessFormData}) {

    console.log('wellnessFormData',wellnessFormData);

    return <div style={{
        display: "flex",
        flexDirection: "column",
        gap:'20px'
    }}>
        <PersonalizationCardImage src={'/assets/survey_personalization_screens/wellness/wellness_welcome.png'} alt={'Welcome Screen'} />

        <PersonalizationInput
            title={'Title'}
                value={wellnessFormData?.welcomeTitle?.toUpperCase()}
            setValue={(value) => setWellnessFormData({welcomeTitle:value?.toUpperCase()})}
            errorMessage={getWellnessError('wellnessSettings', 'welcomeTitle')}
        />


        <PersonalizationInput
            title={'Section Title'}
            value={wellnessFormData?.welcomeSectionTitle}
            setValue={(value) => setWellnessFormData({welcomeSectionTitle:value})}
            errorMessage={getWellnessError('wellnessSettings', 'welcomeSectionTitle')}
        />


        <PersonalizationTextarea
            title={'Description'}
            value={wellnessFormData?.welcomeDescription}
            setValue={(value) => setWellnessFormData({welcomeDescription:value})}
            errorMessage={getWellnessError('wellnessSettings', 'welcomeDescription')}
        />

        <PersonalizationInput
            title={'Video Link (Optional)'}
            value={wellnessFormData?.welcomeVideoLink}
            setValue={(value) => setWellnessFormData({welcomeVideoLink:value})}
            errorMessage={getWellnessError('wellnessSettings', 'welcomeVideoLink')}
        />
    </div>
}
